import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  headerless: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/headerless.vue").then(m => m.default || m))
}